export default function NoteCard({ title, items }) {
  return (
    <div className={`bg-[#FF8C001A] text-sm text-gray-800 p-4 rounded-lg`}>
      <h3 className={`text-[#FF8C00] font-semibold mb-2`}>{title}</h3>
      <ul className="space-y-1">
        {items?.map((item, index) => (
          <li key={index} className="flex items-start">
            <span className="mr-2 rtl:mr-0 rtl:ml-2">•</span>
            <div>{item}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}